// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "+";
const default_addedToCartText = "&check;";
const default_add_all_to_cart_text = "Add All to Cart";
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let currentTab;
let tangent_client_domain_currency;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
} 

// Add default image url here
const tangent_default_selfie_image_url="https://cdn.shopify.com/s/files/1/0308/2610/2915/t/23/assets/synergy_cSlK.png?v=1675265010944";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

// Message for each conditions
const condition_text_mapping = {
    dark_circles: "Prone to dark circles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>.",
    wrinkles: "Prone to wrinkles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    rosacea: "Prone to rosacea here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    texture: "Prone to texture here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    darkspots: "Prone to darkspots here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    acne: "Prone to Blemish here! Try our <a target='_blank' href='#'><u>Product Name</u></a>"
}

window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
    // Current Page Load URL
    let tangent_client_url = new URL(window.location.href);
    return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
    if (tangent_response_id != null) {
        const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
        fetch(checkout_url)
        .then(data => {
            return data.json();
        })
        .then(response => {
            checkoutDataProcess(response);
            return response;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

function checkoutDataProcess(response){
    const tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }
    setElementDisplay("loading-section", "none");
    if (response["selfie_id"] != null) {
        setElementDisplay("tangent-loading-section", "flex");
        setSelfieId(response["selfie_id"]);
        getSelfieMapping(response["selfie_id"]);
        enableSelfieDependedStaticElements();
    }
    else {
        setTangentDefaultSelfie();
    }

    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
        createProductSection(tangent_product_sections, tangent_text_sections);
    }    
  
    if(response.text_sections!=undefined){
        createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData(); 
        setTabActive(response.tags);      
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function setTabActive(tags) {
  const tabWrapper = document.querySelector("#tab-wrapper");
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabLinks = document.querySelectorAll(".tablinks");
  tabWrapper.style.display = "block";

  currentTab = "section_basics";
  let index = 0;

  // Reset all tabs first
  tabContents.forEach(tab => tab.style.display = "none");
  tabLinks.forEach(link => link.classList.remove("active"));

  // Activate selected tab safely
  if (tabContents[index] && tabLinks[index]) {
    tabContents[index].style.display = "block";
    tabLinks[index].classList.add("active");
  }
   handleCarousel();
}

// Setting Selfie / Default Image
function setTangentDefaultSelfie() {
    const selfieImage = document.getElementById("tangent_selfie_image");
    if (tangent_default_selfie_image_url) {
        setElementDisplay("loading-section", "none");
        setElementDisplay("canvas_img", "block");
        setElementDisplay("tangent_selfie_image", "flex");
        selfieImage.src = tangent_default_selfie_image_url;
        // document.getElementById("section_selfie_container_parent").style.borderBottom = "none";
    } else {
        setElementDisplay("tangent_selfie_container", "none");
    }
}


// Selfie Mapping data api call
async function getSelfieMapping(selfie_id) {
    const selfie_api_url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfie_id}&user=mango`;

    try {
        const res = await fetch(selfie_api_url);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        tangent_facemap_data = data?.selfie_record?.[0]?.facemap;
        if (tangent_facemap_data) {
            // Update scores
            setScores(tangent_facemap_data.scores);

            // Update selfie image
            const canvasImg = document.getElementById("canvas_img");
            if (canvasImg) canvasImg.src = tangent_facemap_data.url;
        }

        // Hide loading, show image
        setElementDisplay("selfie-loading-section", "none");
        setElementDisplay("canvas_img", "block");

    } catch (err) {
        console.error("Error fetching selfie:", err);
        setElementDisplay("loading-section", "none");
    }
}

// Setting scores below the selfie
function setScores(scores) {
    let scores_present = false;

    const scoreMap = {
        acne: "Acne",
        rosacea: "Rosacea",
        darkspots: "DarkSpots",
        wrinkles: "Wrinkles",
        dark_circles: "DarkCircles",
        texture: "Texture"
    };

    Object.keys(scores).forEach(key => {
        if (scoreMap[key]) {
            const containerId = `${scoreMap[key]}_Score_container`;
            const scoreId = `#${scoreMap[key]}_Score`;
            setElementDisplay(containerId, "flex");
            document.querySelector(scoreId).innerHTML = scores[key] + "%";
            scores_present = true;
        }
    });

    if (scores_present) {
        setElementDisplay("facemap_all_scores_container", "flex");
    }
}

function switchTab(button) {
    currentTab = button.name;

    document.querySelectorAll(".tabcontent").forEach(tab => {
        tab.style.display = "none";
    });

    document.querySelectorAll(".tablinks").forEach(btn => {
        btn.classList.remove("active");
    });

    const container = document.getElementById(`${button.name}_container`);

    if (container) {
        container.style.display = "flex";
    }

    button.classList.add("active");

    handleCarousel();
}

// Create tab buttons
function createTabButton(sectionName) {
    const tabButton = document.createElement("button");

    tabButton.id = `${sectionName}_tab_button`;
    tabButton.name = sectionName;
    tabButton.innerHTML = getTabTitle(sectionName);

    tabButton.classList.add("tablinks");
    tabButton.addEventListener("click", () => switchTab(tabButton));

    tangent_custom_tabs.appendChild(tabButton);
}

function getTabTitle(section) {
    return tabs_title_mapping[section] ??
        section
            .replace(/^section_/, "")
            .replaceAll("_", " ")
            .toUpperCase();
}

function setProductsToView(products, sections, selected_variants) {
    tangent_selected_product_map = {};

    // Create product lookup map
    const productMap = {};
    products.forEach(product => {
        productMap[String(product.id)] = product;
    });

    Object.keys(sections).forEach(section => {
        const product_ids = sections[section];
        const product_section_grid = document.getElementById(section + "_product_grid");
        if (!product_section_grid) return;

        const fragment = document.createDocumentFragment();
        let sectionProductIndex = 1;
        product_ids.forEach(id => {
            const product = productMap[id];

            if (!product) return;

            const variant = getSelectedVariant(
                product,
                selected_variants?.[product.id]
            );

            tangent_selected_product_map[product.id] = extractVariantId(variant.id);

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = getProductHTML(
                product,
                variant,
                section,
                sections,
                sectionProductIndex
            );
            sectionProductIndex++;
            fragment.append(...tempDiv.childNodes);
        });

        product_section_grid.appendChild(fragment);
    });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractVariantId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function getProductHTML(product, variant, section, sections, productIndex) {
    const variantId = extractVariantId(variant.id);
    const variantImageUrl = getVariantImage(variant, product);
    const variantProductUrl = `${product.onlineStoreUrl}?variant=${variantId}`;

    const variantTitle =
        variant.title === "Default Title" ? "" : variant.title;

    let buttonClass = "";
    let buttonText = default_addToCartText;

    if (isProductAvailable(product, variant)) {
        updateSectionAllToCartLink(
            sections,
            product.id,
            tangent_selected_product_map[product.id],
            section,
            variant
        );
    } else {
        buttonClass = "disable-button";
    }

    return `
        <div class="tangent-product">
            <div>
                <div class="product-step-index">${padToTwoDigits(productIndex)}</div>
                ${getProductCategory(product)}
            </div>
            <div class="tangent-product-image-container">
                <a
                    class="tangent-text-link"
                    target="_blank"
                    href="${variantProductUrl}"
                >
                    <img
                        src="${variantImageUrl}"
                        class="tangent_product_image"
                        alt="${product.title}"
                    >
                </a>

                <button
                    class="btn btn--primary quick-add-btn js-quick-add-btn tangent-product-add-btn-wrapper tangent_add_to_cart_button product-buy-buttons--cta ${buttonClass}"
                    id="${variantId}"
                    data-add-to-cart="${variantId}"
                >
                    ${buttonText}
                </button>
            </div>
            <div>
                <p class="tangent_product_price_text grid-product__price--current">
                    ${tangent_client_domain_currency}${variant.price}
                </p>

                <p class="tangent-vendor-name">
                    ${product.vendor}
                </p>

                <h4 class="tangent-product-title tangent_product_title_text">
                    ${product.title}
                </h4>

                ${
                    variantTitle
                        ? `<p class="tangent_variant_title">${variantTitle}</p>`
                        : ""
                }
            </div>
        </div>
    `;
}

function getProductCategory(product) {
    const category = product.product_category?.value;

    return category
        ? `<p class="tangent-product-category-text">${category}</p>`
        : "";
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status !== "ACTIVE") {
      return false;
  }
  return variant.availableForSale;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(productSections, productId, variantId, sectionName, variant) {
    if (!productSections) return;

    Object.entries(productSections).forEach(([sectionKey, productIds]) => {
        if (!productIds.includes(String(productId))) return;

        const sectionData = sections_add_to_cart_map[sectionKey] ||= {
            count: 0,
            total: 0,
            cart_link: `${tangent_client_domain_url}/cart/add?`,
            list: []
        };

        if (sectionData.list.includes(variantId)) return;
        sectionData.count++;
        sectionData.list.push(variantId);
        sectionData.total += parseFloat(variant.price || 0);
        sectionData.cart_link += `&id[]=${variantId}`;
    });
}

const getVariantImage = (variant, product) => {
  if(variant.image?.url){
    return variant.image.url; 
  }
  else{
    if(product.images?.nodes[0]?.url){
        return product.images.nodes[0].url
    }
    else{
      return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
  }
}

function createFormDataFromIds(idArray) {
    return {
        items: idArray.map(id => ({
        id: id,
        quantity: 1
        }))
    };
}

function addToCart(element){ 
    const formData = createFormDataFromIds([element.id]);
    addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
    const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
    if(formData){
        addToCartApi(formData, element);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function addToCartApi(payload, element){ 
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then(async (response) => {
    const data = await response.json();

    if (!response.ok) {
      throw data;
    }

    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 

    setTimeout(updateCartCount, 100);
    
    element.dispatchEvent(
      new CustomEvent("cart-drawer:refresh", {
        detail: { response: response },
        bubbles: true,
        composed: true
      })
    );
    return data;
  })
  .catch((error) => {
    if (error && error.status) {
      const message = error.message || "Something went wrong";

      element.innerHTML = default_addToCartText;
      element.classList.remove("added-to-cart-style");

      showCartError(element, message);
    } 

    element.dispatchEvent(
      new CustomEvent("cart-drawer:refresh", {
        detail: { response: error },
        bubbles: true,
        composed: true
      })
    );
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;
      const countEl = document.querySelector('[data-cart-count]');
      const bubble = document.querySelector('[data-cart-count-bubble]');
      // update count
      if (countEl) {
        countEl.textContent = count;
      }

      // show/hide bubble
      if (bubble) {
        if (count > 0) {
          bubble.classList.remove('hide');   
          bubble.style.display = 'flex';   
        } else {
          bubble.classList.add('hide');
        }
      }
    })
    .catch(err => console.error('Cart fetch error:', err));
}

const padToTwoDigits = (num) => {
  return String(num).padStart(2, '0');
};

function showCartError(targetElement, message) {
  if (!targetElement) return;

  const parent = targetElement.parentNode;

  // Remove existing message
  const existing = parent.querySelector('.tangent-cart-error-msg');
  if (existing) existing.remove();

  const el = document.createElement('p');
  el.textContent = message;
  el.className = 'tangent-cart-error-msg';

  targetElement.insertAdjacentElement('afterend', el);

  // Store timeout on element to prevent multiple timers
  if (targetElement._errorTimeout) {
    clearTimeout(targetElement._errorTimeout);
  }

  targetElement._errorTimeout = setTimeout(() => {
    const msg = parent.querySelector('.tangent-cart-error-msg');
    if (msg) msg.remove();
  }, 4000);
}

function addResponseTextBelow(element, response){
  const textEl = document.createElement('p');
  textEl.textContent = response.message;
  element.insertAdjacentElement('afterend', textEl);
}

function handleCarousel() {
    const container = document.getElementById(`${currentTab}_product_grid`);
    if (!container) return;
    const wrapper = container.closest(".carousel-wrapper");
    if (!wrapper) return;

    const hasOverflow = container.scrollWidth > container.clientWidth;

    container.classList.toggle("center-mode", !hasOverflow);

    toggleCarouselNav(wrapper, hasOverflow);
}


function extractVariantId(variantId) {
  return variantId.replace("gid://shopify/ProductVariant/", "");
}


// Main Section container 
function createSectionContainer(section_name) {
    const section_container = document.createElement("div");
    section_container.id = `${section_name}_container`;

    const excludedSections = [
        "section_selfie",
        "section_custom_content",
        "section_professional_content"
    ];

    if (!excludedSections.includes(section_name)) {
        section_container.classList.add("tabcontent");
    }
    return section_container;
}

function createSectionAddAllToCart(sectionName) {
    const button = document.createElement("button");
    button.id = sectionName;
    button.classList.add(
        "section_add_all_to_cart",
        `${sectionName}_add_all_to_cart`,
        "btn"
    );
    button.textContent = default_add_all_to_cart_text;
    button.addEventListener("click", () => {
        addAllTocartFunction(button);
    });
    return button;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    const carouselWrapper = document.createElement("div");
    carouselWrapper.className = "carousel-wrapper";

    // Left button
    const leftButton = document.createElement("button");
    leftButton.className = "nav-btn left";
    leftButton.onclick = () => scrollProducts(-1);

    leftButton.innerHTML = `
        &#8592;
    `;

    // Product grid
    const productGridViewContainer = document.createElement("div");
    productGridViewContainer.id = `${section_name}_product_grid`;
    productGridViewContainer.className = `section_product_grid ${section_name}_product_grid`;

    // Right button
    const rightButton = document.createElement("button");
    rightButton.className = "nav-btn right";
    rightButton.onclick = () => scrollProducts(1);

    rightButton.innerHTML = `
        &#8594;
    `;

    carouselWrapper.append(
        leftButton,
        productGridViewContainer,
        rightButton
    );

    return carouselWrapper;
}

function scrollProducts(direction) {
  const container = document.getElementById(currentTab+"_product_grid");

  const scrollAmount = container.clientWidth * 0.8;

  container.scrollBy({
    left: direction * scrollAmount,
    behavior: "smooth"
  });
}

function toggleCarouselNav(wrapper, showButtons) {
    wrapper.querySelectorAll(".nav-btn").forEach(btn => {
        btn.style.display = showButtons ? "block" : "none";
    });
}

function createProductSection(product_sections, text_sections) {
    const order = [
        "section_starter",
        "section_basics",
        "section_essentials",
        "section_works"
    ];

    const sortedSections = Object.fromEntries(
        order
            .filter(key => product_sections[key]?.length)
            .map(key => [key, product_sections[key]])
    );

    for (const section_name in sortedSections) {
        const section_container = createSectionContainer(section_name);

        if (text_sections) {
            createTextSectionBeforeProducts(
                text_sections,
                section_container,
                section_name
            );
        }

        section_container.appendChild(
            addSectionProductGridContainer(
                section_name,
                product_sections[section_name].length > 1
            )
        );

        if (product_sections[section_name].length > 1) {
            section_container.appendChild(
                createSectionAddAllToCart(section_name)
            );
        }

        tangent_sections_wrapper_element.appendChild(section_container);

        createTabButton(section_name);
    }
}

// Text Sections with product sections
function createTextSectionBeforeProducts(textSections, sectionContainer, sectionName) {
    const content = textSections[sectionName];

    if (!content) {
        return;
    }

    const sectionDiv = document.createElement("div");

    sectionDiv.id = `${sectionName}_text_container`;
    sectionDiv.classList.add(
        "section_text_container",
        `${sectionName}_text_container`
    );

    sectionDiv.innerHTML = content.join(" ");

    sectionContainer.appendChild(sectionDiv);
}

// Section Text Creation (one without a product section)
function createTextSection(productSections, textSections) {
    for (const sectionName in textSections) {

        // Skip duplicate entries
        if (productSections[sectionName] !== undefined) {
            continue;
        }

        const sectionContainer = createSectionContainer(sectionName);

        const sectionDiv = document.createElement("div");
        sectionDiv.id = `${sectionName}_text_container`;
        sectionDiv.classList.add(
            "section_text_container",
            `${sectionName}_text_container`
        );

        sectionDiv.innerHTML = textSections[sectionName].join(" ");
        sectionContainer.appendChild(sectionDiv);

        let targetContainer = tangent_sections_wrapper_element;

        // Add to specific containers
        if (sectionName === "section_custom_content") {
            targetContainer = document.querySelector(
                "#section_custom_content_container"
            );
        }

        // section_selfie intentionally skipped
        if (
            sectionName !== "section_selfie" &&
            targetContainer
        ) {
            targetContainer.appendChild(sectionContainer);
        }
    }
}

// Enabling button listeners
function enableButtonListener(){
    const buttons = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    if (!buttons.length) return;

    buttons.forEach(btn => {
        btn.addEventListener('click', function () {
            addToCart(this);
        });
    });
}

// Show elements after response data loads
function loadElementsOnResponseData(){
    const elements = document.querySelectorAll('.load-on-data');
    if (!elements.length) return;

    elements.forEach(el => {
        el.style.display = "block";
    });
}

function setElementDisplay(elementId, display) {
    const el = document.querySelector("#" + elementId);
    if (el) {
        el.style.display = display;
    }
}

function enableSelfieDependedStaticElements() {
    setElementDisplay("tangent_score_description", "block");
}

function setSelfieId(id) {
    tangent_selfie_id = id;
}

function getSelfieId() {
    return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas() {
    if (getSelfieId() != null) {

        var selfie_canvas = document.querySelector('#selfie_canvas');
        var selfie_canvas_ctx = selfie_canvas.getContext('2d');

        selfie_canvas.addEventListener('click', function (e) {
            getCursorPosition(selfie_canvas, e)
        });

        var canvas_img = document.querySelector('#canvas_img');
        setCanvasDimensions(selfie_canvas, canvas_img);

        var prop = getImageSize(canvas_img.naturalWidth);

        drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
        drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
        drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
        drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
        drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
        drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"], getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
    selfie_canvas.width = canvas_img.naturalWidth;
    selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
    var prop = imgWidth / 400;
    return prop;
}

const getDarkCircleBlur = (prop) => {
    if (prop < 1) {
        return 'blur(1px)';
    }
    else if (prop < 1.5) {
        return 'blur(2px)';
    }
    else if (prop < 2) {
        return 'blur(4px)';
    }
    else if (prop < 3) {
        return 'blur(7px)';
    }
    else if (prop < 4) {
        return 'blur(12px)';
    }
    else {

    }
}

const getRosaceaBlur = (prop) => {
    if (prop < 1) {
        return 'blur(4px)';
    }
    else if (prop < 1.5) {
        return 'blur(4px)';
    }
    else if (prop < 2) {
        return 'blur(5px)';
    }
    else if (prop < 3) {
        return 'blur(13px)';
    }
    else if (prop < 4) {
        return 'blur(18px)';
    }
    else {
        console.log("out of bound props - Rosacea");
    }
}

const getAcneLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 7;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - Acne");
    }
}

const getDarkSpotsLineWidth = (prop) => {
    if (prop < 1) {
        return 1;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 6;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - DarkSpots");
    }
}

const getTextureLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 3;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 16;
    }
    else {
        return 20;
    }
}

const getWrinkleLineWidth = (prop) => {
    if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 15;
    }
    else if (prop < 4) {
        return 30;
    }
    else {
        console.log("out of bound props - Wrinkle");
    }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(28, 30, 82, 0.3)';
    drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
    context.fillStyle = 'rgba(24, 96, 3, 0.5)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(24, 96, 3, 0.5)";
    drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(206, 66, 66, 0.5)';
    drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
    context.lineWidth = lineWidth;
    context.filter = 'none';
    context.strokeStyle = "rgba(186, 111, 223, 0.5)";
    drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
    context.fillStyle = 'rgba(81, 212, 191, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(81, 212, 191, 0.4)";
    drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
    context.fillStyle = 'rgba(234, 220, 96, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(234, 220, 96, 0.4)";
    drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
    for (let i = 0; i < contours.length; i++) {
        drawContour(context, contours[i], fill, stroke)
    }
}

const drawContour = (context, contour_coordinates, fill = false, stroke = false) => {
    context.beginPath();
    for (let i = 0; i < contour_coordinates.length; i++) {
        let point = contour_coordinates[i]
        if (i == 0) {
            context.moveTo(point[0], point[1]);
        } else {
            context.lineTo(point[0], point[1]);
        }
    }
    context.closePath();
    if (fill) context.fill();
    if (stroke) context.stroke();
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

    const ctx = canvas.getContext('2d');
    const bb = canvas.getBoundingClientRect();
    var point = {
        _x: Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
        _y: Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
    }

    var skin_conditions = ["acne", "darkspots", "wrinkles", "dark_circles", "rosacea"];
    var click_found = false;
    for (var sc = 0; sc < skin_conditions.length; sc++) {
        if (isPointInsidePoligon(point, tangent_facemap_data[skin_conditions[sc]])) {
            // openConditionMessage(canvas, skin_conditions[sc]);
            click_found = true;
            break;
        }
    }
    if (!click_found) {
        tangent_condition_message_popoup.style.display = "none";
        console.log("no condition click");
    }
}

function openConditionMessage(canvas, condition) {
    tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
    let rect = canvas.getBoundingClientRect();
    var point = {
        _x: event.clientX - rect.left,
        _y: event.clientY - rect.top
    }

    // Positioning Popup
    Object.assign(
        tangent_condition_message_popoup.style,
        {
            display: "block",
            left: (point._x) + "px",
            top: (point._y) + "px"
        }
    );
}


// Check whether click is inside condition points
function isPointInsidePoligon(pt, points_list) {
    // https://stackoverflow.com/a/29915728/960654
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

    var x = pt._x,
        y = pt._y

    var inside = false;
    for (var c = 0; c < points_list.length; c++) {
        var points = points_list[c];
        for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
            var xi = points[i][0],
                yi = points[i][1]
            var xj = points[j][0],
                yj = points[j][1]

            var intersect =
                yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
            if (intersect) inside = !inside
        }
    }
    return inside
}